// extracted by mini-css-extract-plugin
export default {"root":"ContactLink_root__JzCAc","root_size_lg":"ContactLink_root_size_lg__yd+Bv"};